import { ProjectFields } from '@/components/projects/form/ProjectForm';
import { ProjectDTO } from '@/data/services/projectServices';
import { ProjectCourseFlagEnum } from '@/models/Flag';
import Flag, { CourseFlag } from '@/models/Flag';
import Hackathon from '@/models/Hackathon';
import { Project } from '@/models/Project';

export function isCourseFlag(flag: Pick<Flag, 'name'>): flag is CourseFlag {
  const courseTypes = Object.values<string>(ProjectCourseFlagEnum);
  return courseTypes.includes(flag.name);
}

export const updateCourseFlag = (courseFlag?: Flag, flags: Flag[] = []) => {
  if (!courseFlag) return flags;
  if (!flags.some(flag => isCourseFlag(flag))) return flags.concat(courseFlag);
  return flags.map(flag => (isCourseFlag(flag) ? courseFlag : flag));
};

export const getCourseFlag = (flags: Flag[] = []) => {
  for (const flag of flags) {
    if (isCourseFlag(flag)) return flag;
  }
};

export const generateFlagsPayload = (
  flagFields: Partial<Pick<ProjectFields, 'courseFlag' | 'isHackathon'>>,
  hackathon?: Hackathon,
  flags?: Flag[],
) => {
  const updatedFlags = updateCourseFlag(flagFields.courseFlag, flags);
  let flagsIds = updatedFlags?.map(flag => flag.id);
  if (flagFields.isHackathon && hackathon) flagsIds.push(hackathon?.flagId);
  flagsIds = Array.from(new Set(flagsIds));
  flagsIds = flagsIds.sort();
  return { flagsIds };
};

export function isObjectUrl(url?: string): boolean {
  return url?.startsWith('blob:') ?? false;
}

export const generateImagePayload = (
  imageFields: Partial<Pick<ProjectFields, 'image' | 'imageFile'>>,
): Pick<ProjectDTO, 'image' | 'imageUrl'> => {
  if (isObjectUrl(imageFields.image))
    return {
      image: imageFields.imageFile,
    };
  return {
    imageUrl: imageFields.image,
  };
};

export const generateDocumentationPayload = (
  documentationField: Partial<Pick<ProjectDTO, 'documentation'>>,
): Pick<ProjectDTO, 'documentation'> => {
  return {
    documentation: documentationField.documentation,
  };
};

export const adapterProjectToCreateProject = (project: Partial<Project>) => {
  const createProject: Partial<ProjectDTO> = {
    projectUrl: project?.projectUrl,
    title: project?.title,
    equipName: project?.equipName,
    description: project?.description,
    shared: project?.shared,
    toolId: project?.tool?.id,
    imageUrl: project?.image,
    usersIds: project?.users?.map(user => user.id),
    flagsIds: project?.flags?.map(flag => flag.id).sort(),
    teacherMentorId: project.teacherMentor?.id,
    documentation: project?.documentation,
    video: project?.video,
    unitsIds: project.units?.map(unit => unit.id),
  };
  return createProject;
};
